import { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Chip,
} from "@material-ui/core";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Btn from "../../../../components/buttons/Btn";
import { FornecedorContext } from "../contexts/FornecedorContext";
import useFornecedorController from "../controllers/FornecedorController";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import { HeaderAccordion } from "../styles/Fornecedor";
import { LabelStyled } from "../../../../theme/styles/Utils";

export default function AccordionFonecedorIntegracao() {
  const {
    //Contato
    expanded,
    geralErrors,
    providerType,
    setProviderType,
    integrationDueDate,
    setIntegrationDueDate,
    integrationConectionCod,
    setIntegrationConectionCod,
    optionsFilterProvider,
    integrationCpfcnpj,
    integrationDescription,
  } = useContext(FornecedorContext);
  const {
    handleChangeOpenAcordion,
    handleChangeIntegrationCpfCnpj,
    sendRpaFornecedor,
  } = useFornecedorController();

  const { queryParams } = useContext(QueryParamsContext);

  return (
    <>
      <Grid item>
        <Accordion
          expanded={expanded.inter || false}
          onChange={() => handleChangeOpenAcordion("inter")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    bgcolor={
                      !expanded.general &&
                      geralErrors.accordions &&
                      geralErrors.accordions.includes("inter")
                        ? "red"
                        : "primary"
                    }
                    textcolor="white"
                    label="INTEGRAÇÕES"
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2} justifyContent="flex-start">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <LabelStyled>
                  Este processo permitirá capturar automaticamente seus boletos
                  com os fornecedores de serviço disponíveis. O Qyon bot ficará
                  responsável por capturar, incluir ou atualizar seus títulos a
                  pagar com a data de vencimento, valor e anexo da conta a ser
                  paga.
                </LabelStyled>
              </Grid>
              <Grid item lg={4} md={3} sm={12} xs={12}>
                <SelectErp
                  loading={false}
                  id="providerType"
                  variant="filled"
                  label="Fornecedor do Serviço"
                  lg={12}
                  value={providerType}
                  setValue={setProviderType}
                  optionsList={optionsFilterProvider}
                  descriptionField="descricao"
                />
              </Grid>
              <Grid item lg={4} md={3} sm={6} xs={12}>
                <TextFieldErp
                  id="integrationConectionCod"
                  label="Código de Ligação"
                  value={integrationConectionCod}
                  setValue={setIntegrationConectionCod}
                  helperText={geralErrors.integrationConectionCod || ""}
                  disabled={providerType?.id === 1 || !providerType}
                  error={geralErrors.integrationConectionCod ? true : false}
                />
              </Grid>
              <Grid item lg={4} md={2} sm={6} xs={12}>
                <TextFieldErp
                  label="Ultimo Vencimento"
                  maxLength={50}
                  defaultValue=""
                  value={integrationDueDate}
                  setValue={setIntegrationDueDate}
                  type="date"
                  helperText={geralErrors.integrationDueDate || ""}
                  disabled={providerType?.id === 1 || !providerType}
                  error={geralErrors.integrationDueDate ? true : false}
                />
              </Grid>
              <Grid item lg={2} md={3} sm={6} xs={12}>
                <TextFieldErp
                  id="geralCpfcnpj"
                  label="CNPJ/CPF"
                  value={integrationCpfcnpj}
                  onChange={handleChangeIntegrationCpfCnpj}
                  disabled={providerType?.id === 1 || !providerType}
                />
              </Grid>
              {queryParams.nfe_resptec_email === "atendimento@qyon.com.br" && (
                <Grid item>
                  <Grid>
                    <Btn
                      label="Envio RPA"
                      bgcolor="tertiary"
                      onClick={sendRpaFornecedor}
                      disabled={providerType?.id === 1 || !providerType}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <LabelStyled id="integracaoDescription">
                      {integrationDescription}
                    </LabelStyled>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
